import React, { FC } from "react";
import { ICountry } from "src/@types/country";
import { getImageUrl } from "src/utils/getImageUrl";

interface Props {
  city?: string;
  country: ICountry;
}

export const Location: FC<Props> = ({ city, country }) => {
  return (
    <p className="flex items-center gap-2">
      {city && <span>{city}</span>}
      <img
        className="rounded-full object-cover w-7 h-7"
        src={getImageUrl(country.icon)}
        alt={country.name}
        title={country.slug}
      />
    </p>
  );
};
